/* eslint-disable no-param-reassign */
import Fetch, { V1 } from 'Util/fetcher';

//= ==============================================================================================//
//                                            CREATE                                              //
//= ==============================================================================================//

const ON_CREATE_AUTO_ORDER = 'ON_CREATE_AUTO_ORDER';
const ON_CREATE_AUTO_ORDER_SUCCESS = 'ON_CREATE_AUTO_ORDER_SUCCESS';
const ON_CREATE_AUTO_ORDER_FAILURE = 'ON_CREATE_AUTO_ORDER_FAILURE';

export function onCreateAutoOrder() {
  return {
    type: ON_CREATE_AUTO_ORDER,
  };
}

export function onCreateAutoOrderSuccess(payload) {
  return {
    type: ON_CREATE_AUTO_ORDER_SUCCESS,
    payload,
  };
}

export function onCreateAutoOrderFailure(payload) {
  return {
    type: ON_CREATE_AUTO_ORDER_FAILURE,
    payload,
  };
}

//= ==============================================================================================//
//                                              GET LIST                                          //
//= ==============================================================================================//

const ON_REQUEST_LIST_AUTO_ORDER = 'ON_REQUEST_LIST_AUTO_ORDER';
const ON_REQUEST_LIST_AUTO_ORDER_SUCCESS = 'ON_REQUEST_LIST_AUTO_ORDER_SUCCESS';
const ON_REQUEST_LIST_AUTO_ORDER_FAILURE = 'ON_REQUEST_LIST_AUTO_ORDER_FAILURE';

const ON_REQUEST_LIST_AUTO_ORDER_MARGIN = 'ON_REQUEST_LIST_AUTO_ORDER_MARGIN';
const ON_REQUEST_LIST_AUTO_ORDER_MARGIN_SUCCESS = 'ON_REQUEST_LIST_AUTO_ORDER_MARGIN_SUCCESS';
const ON_REQUEST_LIST_AUTO_ORDER_MARGIN_FAILURE = 'ON_REQUEST_LIST_AUTO_ORDER_MARGIN_FAILURE';

function onRequestListAutoOrder(resetData) {
  return {
    type: ON_REQUEST_LIST_AUTO_ORDER,
    meta: { resetData },
  };
}

function onRequestListAutoOrderSuccess(payload) {
  return {
    type: ON_REQUEST_LIST_AUTO_ORDER_SUCCESS,
    payload,
  };
}

function onRequestListAutoOrderFailure(payload) {
  return {
    type: ON_REQUEST_LIST_AUTO_ORDER_FAILURE,
    payload,
  };
}

export const onDoRequestListAutoOrder =
  (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestListAutoOrder(resetData));
    Fetch.get(`${V1}stock/auto-trading/${payload}&account_type=REG`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestListAutoOrderSuccess(resp.json));
        } else {
          dispatch(onRequestListAutoOrderFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestListAutoOrderFailure(error.message));
      });
  };

export const onDoResetListAutoOrder = () => (dispatch) => {
  dispatch(onRequestListAutoOrder(true));
};
//
function onRequestListAutoOrderMargin(resetData) {
  return {
    type: ON_REQUEST_LIST_AUTO_ORDER_MARGIN,
    meta: { resetData },
  };
}

function onRequestListAutoOrderMarginSuccess(payload) {
  return {
    type: ON_REQUEST_LIST_AUTO_ORDER_MARGIN_SUCCESS,
    payload,
  };
}

function onRequestListAutoOrderMarginFailure(payload) {
  return {
    type: ON_REQUEST_LIST_AUTO_ORDER_MARGIN_FAILURE,
    payload,
  };
}

export const onDoRequestListAutoOrderMargin =
  (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestListAutoOrderMargin(resetData));
    Fetch.get(`${V1}stock/auto-trading/${payload}&account_type=MARGIN`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestListAutoOrderMarginSuccess(resp.json));
        } else {
          dispatch(onRequestListAutoOrderMarginFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestListAutoOrderMarginFailure(error.message));
      });
  };

export const onDoResetListAutoOrderMargin = () => (dispatch) => {
  dispatch(onRequestListAutoOrderMargin(true));
};

//= ==============================================================================================//
//                                              DELETE OR CANCEL                                  //
//= ==============================================================================================//

const ON_DELETE_AUTO_ORDER = 'ON_DELETE_AUTO_ORDER';
const ON_DELETE_AUTO_ORDER_SUCCESS = 'ON_DELETE_AUTO_ORDER_SUCCESS';
const ON_DELETE_AUTO_ORDER_FAILURE = 'ON_DELETE_AUTO_ORDER_FAILURE';

function onDeleteAutoOrder() {
  return {
    type: ON_DELETE_AUTO_ORDER,
  };
}

function onDeleteAutoOrderSuccess(payload) {
  return {
    type: ON_DELETE_AUTO_ORDER_SUCCESS,
    payload,
  };
}

function onDeleteAutoOrderFailure(payload) {
  return {
    type: ON_DELETE_AUTO_ORDER_FAILURE,
    payload,
  };
}

export const onDoDeleteAutoOrder = (id) => (dispatch) => {
  dispatch(onDeleteAutoOrder());
  Fetch.put(`${V1}stock/auto-trading/${id}/cancel/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onDeleteAutoOrderSuccess(resp.json));
      } else {
        dispatch(onDeleteAutoOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onDeleteAutoOrderFailure(error.message));
    });
};

//= ==============================================================================================//
//                                      PAUSE                                                     //
//= ==============================================================================================//

const ON_PAUSE_AUTO_ORDER = 'ON_PAUSE_AUTO_ORDER';
const ON_PAUSE_AUTO_ORDER_SUCCESS = 'ON_PAUSE_AUTO_ORDER_SUCCESS';
const ON_PAUSE_AUTO_ORDER_FAILURE = 'ON_PAUSE_AUTO_ORDER_FAILURE';

function onPauseAutoOrder() {
  return {
    type: ON_PAUSE_AUTO_ORDER,
  };
}

function onPauseAutoOrderSuccess(payload) {
  return {
    type: ON_PAUSE_AUTO_ORDER_SUCCESS,
    payload,
  };
}

function onPauseAutoOrderFailure(payload) {
  return {
    type: ON_PAUSE_AUTO_ORDER_FAILURE,
    payload,
  };
}

export const onDoPauseAutoOrder = (id) => (dispatch) => {
  dispatch(onPauseAutoOrder());
  Fetch.put(`${V1}stock/auto-trading/${id}/pause/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onPauseAutoOrderSuccess(resp.json));
      } else {
        dispatch(onPauseAutoOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onPauseAutoOrderFailure(error.message));
    });
};

//= ==============================================================================================//
//                                               RESUME                                          //
//= ==============================================================================================//

const ON_RESUME_AUTO_ORDER = 'ON_RESUME_AUTO_ORDER';
const ON_RESUME_AUTO_ORDER_SUCCESS = 'ON_RESUME_AUTO_ORDER_SUCCESS';
const ON_RESUME_AUTO_ORDER_FAILURE = 'ON_RESUME_AUTO_ORDER_FAILURE';

function onResumeAutoOrder() {
  return {
    type: ON_RESUME_AUTO_ORDER,
  };
}

function onResumeAutoOrderSuccess(payload) {
  return {
    type: ON_RESUME_AUTO_ORDER_SUCCESS,
    payload,
  };
}

function onResumeAutoOrderFailure(payload) {
  return {
    type: ON_RESUME_AUTO_ORDER_FAILURE,
    payload,
  };
}

export const onDoResumeAutoOrder = (id) => (dispatch) => {
  dispatch(onResumeAutoOrder());
  Fetch.put(`${V1}stock/auto-trading/${id}/resume/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onResumeAutoOrderSuccess(resp.json));
      } else {
        dispatch(onResumeAutoOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onResumeAutoOrderFailure(error.message));
    });
};

//= ==============================================================================================//
//                                              UPDATE                                            //
//= ==============================================================================================//

const ON_UPDATE_AUTO_ORDER = 'ON_UPDATE_AUTO_ORDER';
const ON_UPDATE_AUTO_ORDER_SUCCESS = 'ON_UPDATE_AUTO_ORDER_SUCCESS';
const ON_UPDATE_AUTO_ORDER_FAILURE = 'ON_UPDATE_AUTO_ORDER_FAILURE';

function onUpdateAutoOrder() {
  return {
    type: ON_UPDATE_AUTO_ORDER,
  };
}

function onUpdateAutoOrderSuccess(payload) {
  return {
    type: ON_UPDATE_AUTO_ORDER_SUCCESS,
    payload,
  };
}

function onUpdateAutoOrderFailure(payload) {
  return {
    type: ON_UPDATE_AUTO_ORDER_FAILURE,
    payload,
  };
}

export const onDoUpdateAutoOrder = (payload, id) => (dispatch) => {
  dispatch(onUpdateAutoOrder());
  Fetch.put(`${V1}stock/auto-trading/${id}/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onUpdateAutoOrderSuccess(resp.json));
      } else {
        dispatch(onUpdateAutoOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onUpdateAutoOrderFailure(error.message));
    });
};

const ON_SAVE_CREATE_AUTO_ORDER = 'ON_SAVE_CREATE_AUTO_ORDER';

function onSaveCreateAutoOrder(payload) {
  return {
    type: ON_SAVE_CREATE_AUTO_ORDER,
    payload,
  };
}

export const onDoSaveCreateAutoOrder = (payload) => (dispatch) => {
  dispatch(onSaveCreateAutoOrder(payload));
};

const INITIAL_STATE = {
  createAutoOrderLoading: null,
  createAutoOrderError: null,
  createAutoOrderSuccess: null,

  listAutoOrder: null,
  listAutoOrderError: null,
  listAutoOrderLoading: null,

  listAutoOrderMargin: null,
  listAutoOrderMarginError: null,
  listAutoOrderMarginLoading: null,

  deleteAutoOrderLoading: null,
  deleteAutoOrderSuccess: null,
  deleteAutoOrderError: null,

  pauseAutoOrderLoading: null,
  pauseAutoOrderSuccess: null,
  pauseAutoOrderError: null,

  resumeAutoOrderLoading: null,
  resumeAutoOrderSuccess: null,
  resumeAutoOrderError: null,

  updateAutoOrder: null,
  updateAutoOrderSuccess: null,
  updateAutoOrderError: null,

  saveAutoOrder: null,
};

const autoOrder = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    // CREATE
    case ON_CREATE_AUTO_ORDER:
      return {
        ...state,
        createAutoOrderLoading: true,
        createAutoOrderError: null,
        createAutoOrderSuccess: null,
      };
    case ON_CREATE_AUTO_ORDER_SUCCESS:
      return {
        ...state,
        createAutoOrderLoading: true,
        createAutoOrderError: null,
        createAutoOrderSuccess: action.payload,
      };
    case ON_CREATE_AUTO_ORDER_FAILURE:
      return {
        ...state,
        createAutoOrderLoading: true,
        createAutoOrderError: action.payload,
        createAutoOrderSuccess: null,
      };

    // GET
    case ON_REQUEST_LIST_AUTO_ORDER:
      return {
        ...state,
        listAutoOrderLoading: true,

        ...(action.meta.resetData ? { listAutoOrder: null } : {}),
        listAutoOrderError: null,

        createAutoOrderLoading: null,
        createAutoOrderError: null,
        createAutoOrderSuccess: null,

        deleteAutoOrderLoading: null,
        deleteAutoOrderSuccess: null,
        deleteAutoOrderError: null,

        pauseAutoOrderLoading: null,
        pauseAutoOrderSuccess: null,
        pauseAutoOrderError: null,

        resumeAutoOrderLoading: null,
        resumeAutoOrderSuccess: null,
        resumeAutoOrderError: null,

        updateAutoOrder: null,
        updateAutoOrderSuccess: null,
        updateAutoOrderError: null,
      };

    case ON_REQUEST_LIST_AUTO_ORDER_SUCCESS:
      if (state.listAutoOrder) {
        const oldResults = [...state.listAutoOrder.results];
        state.listAutoOrder = {
          ...action.payload,
          results: [...oldResults, ...action.payload.results],
        };
      } else {
        state.listAutoOrder = action.payload;
      }
      return {
        ...state,
        listAutoOrderLoading: false,
        listAutoOrderError: null,
      };

    case ON_REQUEST_LIST_AUTO_ORDER_FAILURE:
      return {
        ...state,
        listAutoOrderLoading: false,
        listAutoOrderError: action.payload,
      };

    case ON_REQUEST_LIST_AUTO_ORDER_MARGIN:
      return {
        ...state,
        listAutoOrderMarginLoading: true,

        ...(action.meta.resetData ? { listAutoOrderMargin: null } : {}),
        listAutoOrderMarginError: null,

        createAutoOrderLoading: null,
        createAutoOrderError: null,
        createAutoOrderSuccess: null,

        deleteAutoOrderLoading: null,
        deleteAutoOrderSuccess: null,
        deleteAutoOrderError: null,

        pauseAutoOrderLoading: null,
        pauseAutoOrderSuccess: null,
        pauseAutoOrderError: null,

        resumeAutoOrderLoading: null,
        resumeAutoOrderSuccess: null,
        resumeAutoOrderError: null,

        updateAutoOrder: null,
        updateAutoOrderSuccess: null,
        updateAutoOrderError: null,
      };

    case ON_REQUEST_LIST_AUTO_ORDER_MARGIN_SUCCESS:
      if (state.listAutoOrderMargin) {
        const oldResults = [...state.listAutoOrderMargin.results];
        state.listAutoOrderMargin = {
          ...action.payload,
          results: [...oldResults, ...action.payload.results],
        };
      } else {
        state.listAutoOrderMargin = action.payload;
      }
      return {
        ...state,
        listAutoOrderMarginLoading: false,
        listAutoOrderMarginError: null,
      };

    case ON_REQUEST_LIST_AUTO_ORDER_MARGIN_FAILURE:
      return {
        ...state,
        listAutoOrderMarginLoading: false,
        listAutoOrderMarginError: action.payload,
      };

    // DELETE
    case ON_DELETE_AUTO_ORDER:
      return {
        ...state,
        deleteAutoOrderLoading: true,
        deleteAutoOrderSuccess: null,
        deleteAutoOrderError: null,
      };
    case ON_DELETE_AUTO_ORDER_SUCCESS:
      return {
        ...state,
        deleteAutoOrderLoading: false,
        deleteAutoOrderSuccess: action.payload,
        deleteAutoOrderError: null,
      };
    case ON_DELETE_AUTO_ORDER_FAILURE:
      return {
        ...state,
        deleteAutoOrderLoading: false,
        deleteAutoOrderSuccess: null,
        deleteAutoOrderError: action.payload,
      };
    // PAUSE
    case ON_PAUSE_AUTO_ORDER:
      return {
        ...state,
        pauseAutoOrderLoading: true,
        pauseAutoOrderSuccess: null,
        pauseAutoOrderError: null,
      };
    case ON_PAUSE_AUTO_ORDER_SUCCESS:
      return {
        ...state,
        pauseAutoOrderLoading: false,
        pauseAutoOrderSuccess: action.payload,
        pauseAutoOrderError: null,
      };
    case ON_PAUSE_AUTO_ORDER_FAILURE:
      return {
        ...state,
        pauseAutoOrderLoading: false,
        pauseAutoOrderSuccess: null,
        pauseAutoOrderError: action.payload,
      };
    // RESUME
    case ON_RESUME_AUTO_ORDER:
      return {
        ...state,
        resumeAutoOrderLoading: true,
        resumeAutoOrderSuccess: null,
        resumeAutoOrderError: null,
      };
    case ON_RESUME_AUTO_ORDER_SUCCESS:
      return {
        ...state,
        resumeAutoOrderLoading: false,
        resumeAutoOrderSuccess: action.payload,
        resumeAutoOrderError: null,
      };
    case ON_RESUME_AUTO_ORDER_FAILURE:
      return {
        ...state,
        resumeAutoOrderLoading: false,
        resumeAutoOrderSuccess: null,
        resumeAutoOrderError: action.payload,
      };

    // UPDATE
    case ON_UPDATE_AUTO_ORDER:
      return {
        ...state,
        updateAutoOrderLoading: true,
        updateAutoOrderSuccess: null,
        updateAutoOrderError: null,
      };
    case ON_UPDATE_AUTO_ORDER_SUCCESS:
      return {
        ...state,
        updateAutoOrderLoading: false,
        updateAutoOrderSuccess: action.payload,
        updateAutoOrderError: null,
      };
    case ON_UPDATE_AUTO_ORDER_FAILURE:
      return {
        ...state,
        updateAutoOrderLoading: false,
        updateAutoOrderSuccess: null,
        updateAutoOrderError: action.payload,
      };

    case ON_SAVE_CREATE_AUTO_ORDER:
      return {
        ...state,
        saveAutoOrder: action.payload,
      };
    default:
      return state;
  }
};

export default autoOrder;
